import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class StartSpinState extends BaseState {
    public begin() {
        const isBuyBonusSpin = !!this._model.isBuyBonusPending

        this._model.resetSpinState()
        GameSignals.startSpin.emit(isBuyBonusSpin && this._model.bonusBuyBet ? this._model.bonusBuyBet : this._model.currentSpinBet)

        this.end()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.GET_SPIN_RESPONSE_STATE)
    }

    public cleanUp() {
        // empty
    }
}
